import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import instance from "../instance"; // Your Axios instance

// Fetch Locations
export const useFetchLocations = (filters) => {
  const fetchLocations = async () => {
    const { data } = await instance.get(`/api/locations?pageNumber=${filters?.pageNumber}&pageSize=${filters?.pageSize}`); // Your API endpoint
    return data;
  };

  const query = useQuery({
    queryKey: ['fetch locations', filters],
    queryFn: fetchLocations,
  });

  return query;
};

// Add Location
export const useAddLocation = () => {
  const queryClient = useQueryClient();
  const addLocationMutation = useMutation(async (newLocation) => {
    const { data } = await instance.post('/api/locations', newLocation); // Your API endpoint
    return data;
  }, {
    onSuccess: () => {
      queryClient.invalidateQueries(['fetch locations']);
    },
  });

  return addLocationMutation;
};

// Update Location
export const useUpdateLocation = () => {
  const queryClient = useQueryClient();
  const updateLocationMutation = useMutation(async (updatedLocation) => {
    const { data } = await instance.put(`/api/locations/${updatedLocation.id}`, updatedLocation); // Include ID
    return data;
  }, {
    onSuccess: () => {
      queryClient.invalidateQueries(['fetch locations']);
    },
  });

  return updateLocationMutation;
};

// Delete Location
export const useDeleteLocation = () => {
  const queryClient = useQueryClient();
  const deleteLocationMutation = useMutation(async (locationId) => {
    await instance.delete(`/api/locations/${locationId}`); // Include ID
  }, {
    onSuccess: () => {
      queryClient.invalidateQueries(['fetch locations']);
    },
  });

  return deleteLocationMutation;
};


// Example Component Usage (similar structure as before):

// const LocationManagement = () => {
//   const { data: locations, isLoading, error } = useFetchLocations();
//   const addLocation = useAddLocation();
//   const updateLocation = useUpdateLocation();
//   const deleteLocation = useDeleteLocation();
//   const [newLocation, setNewLocation] = useState({
//     name: '',
//     address: '',
//     orgId: '',
//     region: '',
//     state: '',
//     cordinate: { lng: '', lat: '' },
//   });
//   const [editLocation, setEditLocation] = useState(null);

//   // ... (handleInputChange, handleAddLocation, handleDeleteLocation, handleEditLocation, handleUpdateLocation functions - same as previous example, but using the mutations)

//   const orgOptions = [ // Replace with your actual organization data/fetching
//     {id:"0a493a88-6208-4e02-93de-93daeb69273f", name: "Acme Corp"},
//     {id:"b7b5c7d8-e9f0-4a2b-9c3d-4e5f6g7h8i9j", name: "Beta Industries"}
// ];

//   const handleAddLocation = async (e) => {
//     e.preventDefault();
//     try {
//       await addLocation.mutateAsync(newLocation);
//       setNewLocation({
//         name: '',
//         address: '',
//         orgId: '',
//         region: '',
//         state: '',
//         cordinate: { lng: '', lat: '' },
//       });
//       alert("Location added successfully!");
//     } catch (error) {
//        console.error("Error adding location:", error);
//       alert("Error adding location. Please try again.");
//     }
//   };

//   const handleDeleteLocation = async (locationId) => {
//     try {
//       await deleteLocation.mutateAsync(locationId);
//       alert("Location deleted successfully!");
//     } catch (error) {
//        console.error("Error deleting location:", error);
//       alert("Error deleting location. Please try again.");
//     }
//   };


//   const handleUpdateLocation = async () => {
//     try {
//       await updateLocation.mutateAsync(editLocation);
//       setEditLocation(null);
//       alert("Location updated successfully!");
//     } catch (error) {
//        console.error("Error updating location:", error);
//       alert("Error updating location. Please try again.");
//     }
//   };


//   if (isLoading) {
//     return <div>Loading locations...</div>;
//   }

//   if (error) {
//     return <div>Error loading locations: {error.message}</div>;
//   }

//   return (
//     <div className="container mx-auto p-4">
//       {/* ... JSX for forms, tables, etc. ... */}

//       {/* Add Location Form */}
//       <form onSubmit={handleAddLocation} className="bg-white rounded-lg shadow-md p-6 mb-4">
//       {/* ... (form inputs - same as before) */}
//       <button type="submit" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4">
//           Add Location
//         </button>
//         </form>

//       {/* Location Table */}
//        <div className="bg-white rounded-lg shadow-md p-6">
//         {/* ... (table - same as before) */}
//         <tbody>
//             {locations?.map((loc) => (
//               <tr key={loc.id}>
//                  {/* ... (table cells - same as before, but make sure to use loc.id for the delete button) */}
//                   <button
//                     onClick={() => handleDeleteLocation(loc.id)} // Pass loc.id to delete mutation
//                     className="text-red-500 hover:text-red-700"
//                   >
//                     Delete
//                   </button>
//               </tr>
//             ))}
//           </tbody>
//       </div>


//       {/* Edit Location Form */}
//       {editLocation && (
//         <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 flex justify-center items-center">
//           <div className="bg-white rounded-lg shadow-md p-6">
//             {/* ... (edit form inputs - same as before) */}
//              <button
//               onClick={handleUpdateLocation} // Call update mutation
//               className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mr-2"
//             >
//               Update
//             </button>
//           </div>
//         </div>
//       )}

//     </div>
//   );
// };

// export default LocationManagement;